import {useSelector} from 'Provider';
import {isWebViewSelector} from 'store/content/content.selectors';

export const useShouldTriggerBread = () => {
  const isWebView = useSelector(isWebViewSelector);
  const path = window?.location?.pathname ?? '';
  const isNotProfilePage = !path.includes('/profile');
  // This condition is to check for non-profile pages of rewards app used in mobile app as webview
  // If true, do not run bread SDK logic
  const webViewNotProfile = isWebView && isNotProfilePage;
  const useSDK = !webViewNotProfile;
  return useSDK;
};
